/**
 * Constantes pour les filtres de routes
 */
export const FILTER_CONSTANTS = {
  MAX_ELEVATION: 9000,
  MAX_DURATION: 10,
  MAX_HEIGHT_DIFF: 9000,
  MAX_HEIGHT_DIFF_DIFFICULTIES: 3000,
  MAX_ROUTE_LENGTH: 500000,
  MIN_DURATION: 1,
} as const;
